import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import CreatePaymentMethoddModal from "./components/CreatePaymentMethod";
import PaymentMethodTable from "./components/PaymentMethodTable";
import { getAllGateways } from "api/graphQL_gateways";
import { getTimeZone } from "api/payments";
import { getCardType } from "api/graphQL_payments";
import { getSingleRole } from "api/graphQL_role";
import { getId } from "utils/auth";
import { ClientContext } from "ClientProvider";

export type PaymentMethodRowObj = {
  id: string; name: string; type: string; logo: string;
  crypto_payin: boolean; crypto_payout: boolean; payments: boolean;
  authorization: boolean; subscription: boolean; payout: boolean;
  refund: boolean; apm: boolean; is_active: boolean;
  direct_debit?: boolean; payin?: boolean; token?: boolean;
};

const PaymentMethod = () => {
  const [paymentData, setPaymentData] = useState<PaymentMethodRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [isListLoading, setIsListLoading] = useState<boolean>();
  const [page, setPage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { singleRoleData, setSingleRoleData } = useContext(ClientContext);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [timeZone, setTimeZone] = useState<any>();
  const [allCardType, setCardType] = useState<any>();

  const fetchUsers = () => {
    setIsListLoading(true);
    getAllGateways(searchTexts)
      .then((data) => { setPaymentData(data ?? []); setPageSize(data?.length); })
      .catch(() => {})
      .finally(() => setIsListLoading(false));
  };

  const fetchTimeZone = () => {
    getTimeZone().then((data) => setTimeZone(data ?? [])).catch(() => {});
  };

  const fetchCardType = () => {
    setIsLoading(true);
    getCardType().then((data) => setCardType(data)).catch(() => {}).finally(() => setIsLoading(false));
  };

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt); setPage(1); setCurrentPage(1);
    } else { await setSearchTexts(search_txt); }
  };

  useEffect(() => { fetchUsers(); }, [searchTexts]);
  useEffect(() => { fetchTimeZone(); fetchCardType(); }, []);

  return (
    <div className="pm-root">
      {/* Page header */}
      <div className="pm-page-header">
        <div className="pm-title-block">
          <div className="pm-page-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
          </div>
          <div>
            <h1 className="pm-heading">Payment Gateways</h1>
            <p className="pm-sub">Manage and configure payment method gateways</p>
          </div>
        </div>
        {/* Create button lives here */}
        <CreatePaymentMethoddModal fetchUsers={fetchUsers} roleData={singleRoleData} />
      </div>

      {/* Table */}
      <PaymentMethodTable
        pageSize={pageSize} setPageSize={setPageSize}
        tableData={paymentData} fetchUsers={fetchUsers}
        isLoading={isListLoading} page={page} setPage={setPage}
        totalpage={totalpage} totalItems={totalItems} currentPage={currentPage}
        roleData={singleRoleData} timeZone={timeZone} allCardType={allCardType}
        onValueChange={serchboxValueChange}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .pm-root { font-family:'Plus Jakarta Sans',sans-serif; display:flex; flex-direction:column; gap:20px; }

        .pm-page-header { display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:16px; }
        .pm-title-block { display:flex; align-items:center; gap:14px; }
        .pm-page-icon { width:44px; height:44px; border-radius:12px; background:linear-gradient(135deg,#eff6ff,#dbeafe); border:1.5px solid #bfdbfe; display:flex; align-items:center; justify-content:center; color:#2563eb; flex-shrink:0; }
        .pm-heading { font-size:20px; font-weight:800; color:#0f172a; letter-spacing:-0.4px; margin-bottom:2px; line-height:1.2; }
        .pm-sub { font-size:13px; color:#94a3b8; font-weight:500; }
      `}</style>
    </div>
  );
};

export default PaymentMethod;